export const ToggleListNewAbsolute = {
  template: `
  <div class="relative search-dropdown">
    <div class="w-full flex content-between search-dropdown-content">
      <div role="button" tabindex="0" :aria-expanded="show ? 'true' : 'false'" @keydown.enter.prevent.stop="display(component)" @keydown.space.prevent.stop="display(component)" @click.stop="display(component)" class="pl-3 p-2 lg:pl-3 lg:p-1 w-full text-dark overflow-hidden cursor-pointer search-dropdown-title">
        {{displayName}}
      </div>
      <div v-show="!show" @click.stop="display(component)"  class="cursor-pointer w-10  bg-white text-center  px-2 pt-1 lg:px-2 lg:pt-1 list-advanced-off">
        <svg aria-hidden="true" focusable="false" width="23" height="22" viewBox="0 0 23 22"  class="w-6 h-6 fill-current text-white list-advanced-svg-off"  xmlns="http://www.w3.org/2000/svg">
          <path d="M17.7513 7L18.6001 7.90562L11.6001 15.4L4.6001 7.90562L5.44447 7L11.6001 13.5844L17.7513 7Z"/>
        </svg>  
        </div>
      <div v-show="show" @click.stop="display(component)" class="cursor-pointer w-10 bg-primary  px-2 pt-1 lg:px-2 lg:pt-1 border border-primary text-center list-advanced-on">
        <svg aria-hidden="true" focusable="false" width="22" height="22" viewBox="0 0 22 22"  class="w-6 h-6 fill-current text-white list-advanced-svg-on"  xmlns="http://www.w3.org/2000/svg">
          <path d="M4.84875 15L4 14.0944L11 6.6L18 14.0944L17.1556 15L11 8.41563L4.84875 15Z"/>
        </svg>
      </div>
    </div>
    <div @click.stop="" v-show="show" class="lg:absolute p-3 w-full z-50 bg-white border border-secondary h-auto max-h-[200px] overflow-y-auto search-dropdown-list">
      <div v-for="item in items" class="search-dropdown-item">
        <label class="custom-checkbox search-dropdown-label">
          {{$t(item)}}
          <input v-model="checked" class="search-dropdown-input" @change="toggle(component)" :key="item" type="checkbox" :value="item" :name="item" :checked="(selected.indexOf(item) != -1) ? true : false">
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
  `,
  data: function () {
      return {
        show: false,
        checked: [],
        displayName: this.title,
        uniqueInList: null,
        theme_directory: window.theme_directory,
      }
    },
    props: [
      'component',
      'title',
      'items',
      'selected',
      'collapse',
      'pivot',
    ],
    methods: {
      display(component){
        this.$emit('hideallcomponents', component);
        this.show = !this.show;
        this.$emit('update', {component, checked: this.checked})
      },
      toggle(component){
         this.$emit('setpivot', component);

         if(this.checked.length == 0){
          this.$emit('unsetpivot', component);
        } 

        this.$emit('updatechecked', {component, checked: this.checked})
        this.$emit('update', {component, checked: this.checked})  

      },
    },
    watch: {
      checked: function (){
        if(this.checked.length > 0)
          this.displayName = this.checked.join(',');
        else
          this.displayName = this.title;
      },
      collapse: function(v){
        this.show = v
      },
      items: function (currentVal) {
        if(currentVal.length == 1)
        {
          this.uniqueInList = currentVal[0];
          this.checked = [];
          this.checked.push(this.uniqueInList);
        }
        else
        {
          if(!this.pivot)
            this.checked = []
        }
      },
    },
    computed: {
    },
}